// @flow
import React from 'react';
import { compose, pure } from 'recompose';
import { analytics, urlCatalog } from 'angieslist-app-platform';
import { ProgressBar } from 'angieslist-react-components';
import { stylesColors } from 'angieslist-styles';
import SingleCard from '../DashboardV2/Card/SingleCard';
import { itemClicked } from '../../../../../app/browser/analyticsHelpers';

type Props = {
    percentComplete: number,
    serviceProviderId: number,
};

const ProfileCompletionCard = ({
  percentComplete,
  serviceProviderId,
}: Props) => (
  <SingleCard
    headerIcon="user"
    headerTitle="Profile Completion"
    ctaText="Complete Your Profile"
    ctaLink={urlCatalog.office.spProfile.about(serviceProviderId)}
    metricValue={`${percentComplete}%`}
    metricLabel={<ProgressBar
      now={percentComplete}
      style={{
    borderRadius: '1em', width: '80%', margin: 'auto', border: `0.5px solid ${stylesColors.backgroundNeutralMedium}`,
}}
    />}
    buttonProps={{ 'data-track-spid': serviceProviderId }}
  />
);

const otherProps = {
  serviceProviderId: '<<attributes.data-track-spid.value>>',
};

const profileCompletionCardAnalytics = {
  elements: {
    'card-cta-button-profile': itemClicked('SP : Home', 'Complete Profile', otherProps),
  },
};

export default (compose(
  analytics({
    ruleset: profileCompletionCardAnalytics,
  }),
  pure,
)(ProfileCompletionCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/ProfileCompletionCard.js